// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"6652f4c0","239":"152b2312","453":"4f157deb","732":"ceb4f2a6"}[chunkId] + ".chunk.js";
};